//External
import React from "react";
import { Modal } from "react-bootstrap";

/*******************
@Purpose : Used for main modal
@Parameter : { showHandler, hideHandler, body, modalTitle }
@Author : INIC
******************/
function MainModal({
  showHandler,
  hideHandler,
  body,
  modalTitle,
  className = false,
  modalTitleClass = false,
  center,
}) {
  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    // onboarding-modal
    <Modal
      show={showHandler}
      onHide={hideHandler}
      className={`${className ? className : "cms-modal"}`}
      centered={center}
    >
      <Modal.Header closeButton>
        <h3
          className={`${
            modalTitleClass
              ? "onboarding-title mb-0 textTransform"
              : "onboarding-title mb-0"
          }`}
        >
          {modalTitle}
        </h3>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
    </Modal>
  );
}

export default MainModal;
